/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { PayoutAccountsResponse } from '../../models/payout-accounts-response';

export interface BookingControllerGetPayoutAccounts$Params {
}

export function bookingControllerGetPayoutAccounts(http: HttpClient, rootUrl: string, params?: BookingControllerGetPayoutAccounts$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: PayoutAccountsResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, bookingControllerGetPayoutAccounts.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: PayoutAccountsResponse;
      }>;
    })
  );
}

bookingControllerGetPayoutAccounts.PATH = '/booking/wallet/payout_accounts';
